module.exports = require("@splunk/dashboard-visualizations/Choropleth");